module.exports = __webpack_public_path__ + "static/img/son4_active.7e75fa72.png";